import { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import { useNavigate } from 'react-router-dom';

import '../App.css';
import Sun from '../assets/icons/dark/Sun.svg';
import LightSun from '../assets/icons/light/Sun.svg';
import SidebarIcon from '../assets/icons/dark/Sidebar.svg';
import LightSidebar from '../assets/icons/light/Sidebar.svg';
import Star from '../assets/icons/dark/Star.svg';
import LightStar from '../assets/icons/light/Star.svg';
import History from '../assets/icons/dark/ClockCounterClockwise.svg';
import LightHistory from '../assets/icons/light/ClockCounterClockwise.svg';
import Bell from '../assets/icons/dark/Bell.svg';
import LightBell from '../assets/icons/light/Bell.svg';
import SearchIcon from '../assets/icons/dark/Search.svg';
import LightSearchIcon from '../assets/icons/light/Search.svg';
import Text from '../assets/icons/dark/Text.svg';
import LightText from '../assets/icons/light/Text.svg';


import SidebarPannel from './Sidebar';
import RightsidePannel from './RightsidePannel';

function Navbar() {
  const { theme, toggleTheme } = useTheme();

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  const [isSidebarOpened, setIsSidebarOpened] = useState(false);
  const toggleSidebarOpened = () => setIsSidebarOpened((prev) => !prev);

  const navigate = useNavigate();
  const navigateToHome = () => {
    navigate('/');
  }

  return (
    <div className="flex transition-all duration-300">
      <SidebarPannel isOpen={isSidebarOpen} />

      <nav
        className={`App flex items-center justify-between h-[68px] px-[28px] py-[20px] border-b-2 transition-all duration-300 ${
          theme === '#1c1c1c' ? 'bg-[#1c1c1c] text-white border-[#333333]' : 'bg-white text-black border-[#e8e8e8]'
        } ${isSidebarOpen ? 'ml-[212px] w-[calc(100%-212px)]' : 'ml-0 w-full'} ${isSidebarOpened ? 'mr-[280px] w-[calc(100%-280px)]' : 'ml-0 w-full'}`}
      >
        <div className="flex items-center gap-2">
          <div className={`p-1 hover:${theme === '#1c1c1c' ? 'bg-[#333333]' : 'bg-[#f3f3f3]'} rounded-lg`}>
          <img
            src={theme === '#1c1c1c' ? SidebarIcon : LightSidebar}
            alt="Sidebar Icon"
            onClick={toggleSidebar}
            className="w-[20px] h-[20px] cursor-pointer"
          />
          </div>
          <div className={`p-1 hover:${theme === '#1c1c1c' ? 'bg-[#333333]' : 'bg-[#f3f3f3]'} rounded-lg`}>
          <img
            src={theme === '#1c1c1c' ? Star : LightStar}
            alt="Star Icon"
            className="w-[20px] h-[20px]"
          />
          </div>
          <p
            className={`text-sm cursor-default py-1 px-2 hover:${theme === '#1c1c1c' ? 'bg-[#333333] text-[#777777]' : 'bg-[#f3f3f3] text-[#a4a4a4]'} rounded-lg`}>
            Dashboards
          </p>
          <p className='cursor-default'>/</p>
          <p className={`text-sm cursor-default py-1 px-2 hover:${theme === '#1c1c1c' ? 'bg-[#333333]' : 'bg-[#f3f3f3]'} rounded-lg`} onClick={navigateToHome}>Default</p>
        </div>

        <div className="flex items-center gap-4">
          {/* search bar */}
          <div className={`flex items-center ${theme === '#1c1c1c' ? 'bg-[#333333]' : 'bg-[#f3f3f3]'} rounded-lg px-2 py-1 h-[28px] w-[160px]`}>
            <img src={theme === '#1c1c1c' ? SearchIcon : LightSearchIcon} alt="Search Icon" className='w-[16px] h-[16px]' />
            <input
              type="text"
              placeholder="Search"
              className={`bg-transparent focus:outline-none ml-1 mt-0.5 w-full text-sm ${theme === '#1c1c1c' ? 'placeholder:text-[#777777] text-white' : 'placeholder:text-[#a4a4a4] text-black'}`}
            />
            <img src={theme === '#1c1c1c' ? Text : LightText} alt="Text Icon" className='w-[20px] h-[20px]' />
          </div>
          <div className={`p-1 hover:${theme === '#1c1c1c' ? 'bg-[#333333]' : 'bg-[#f3f3f3]'} rounded-lg`}>
          <img
            src={theme === '#1c1c1c' ? Sun : LightSun}
            alt="Theme toggle"
            onClick={toggleTheme}
            className="w-[20px] h-[20px] cursor-pointer"
          />
          </div>
          <div className={`p-1 hover:${theme === '#1c1c1c' ? 'bg-[#333333]' : 'bg-[#f3f3f3]'} rounded-lg`}>
          <img
            src={theme === '#1c1c1c' ? History : LightHistory}
            alt="History Icon"
            className="w-[20px] h-[20px]"
          />
          </div>
          <div className={`p-1 hover:${theme === '#1c1c1c' ? 'bg-[#333333]' : 'bg-[#f3f3f3]'} rounded-lg`}>
          <img
            src={theme === '#1c1c1c' ? Bell : LightBell}
            alt="Notification Icon"
            className="w-[20px] h-[20px]"
          />
          </div>
          <div className={`p-1 hover:${theme === '#1c1c1c' ? 'bg-[#333333]' : 'bg-[#f3f3f3]'} rounded-lg`}>
          <img
            src={theme === '#1c1c1c' ? SidebarIcon : LightSidebar}
            alt="Sidebar Icon"
            onClick={toggleSidebarOpened}
            className="w-[20px] h-[20px] cursor-pointer"
          />
          </div>
        </div>
      </nav>
      <RightsidePannel isOpened={isSidebarOpened} />
    </div>
  );
}

export default Navbar;
